/**
 * Module dependencies.
 */

import React from 'react';
import { cn } from 'app/lib/utils';

/**
 * Export `StatCard` — the shared labelled value card used across Crypto Gest
 * (overview, asset detail), so they look identical between pages.
 */

export function StatCard({
  label,
  value,
  sub,
  subClass
}: {
  label: string;
  value: string;
  sub?: string;
  subClass?: string;
}): JSX.Element {
  return (
    <div className={'rounded-xl border border-border bg-card p-4 shadow-sm'}>
      <div className={'text-[11px] font-medium uppercase tracking-wide text-muted-foreground'}>{label}</div>

      <div className={"mt-1 font-['Oswald'] text-2xl font-semibold tabular-nums text-foreground"}>{value}</div>

      {sub && <div className={cn('mt-0.5 text-sm font-medium', subClass ?? 'text-muted-foreground')}>{sub}</div>}
    </div>
  );
}
